import { NgModule } from '@angular/core';

import { AddEvaluationsDropdownModule } from '@recruitee/add-evaluations-dropdown';
import { UnbiasedHiringModule } from '@recruitee/unbiased-hiring';

@NgModule({
  imports: [
    AddEvaluationsDropdownModule.withTranslations({
      interview: {
        evaluationForms: 'app.interview.evaluation_forms',
        evaluationRequest: 'app.interview.evaluation_request',
        required: 'app.interview.required',
        addNow: 'app.interview.add_now',
        template: 'app.interview.template',
        templateHidden: 'app.interview.template_hidden',
        emptyTemplateTitle: 'app.interview.empty_template_title',
        emptyTemplateDescription: 'app.interview.empty_template_description',
        job: 'app.interview.job',
        jobPlaceholder: 'app.interview.job_placeholder',
        templatePlaceholder: 'app.interview.template_placeholder',
        manageForms: 'app.interview.manage_forms',
        cancel: 'app.interview.cancel',
        requestNow: 'app.interview.request_now',
        start: 'app.interview.start',
        fillOutForm: 'app.interview.fill_out_form',
        chooseForm: 'app.interview.choose_form',
        scheduleDialog: {
          requestFrom: 'app.interview.schedule_dialog.request_from',
          requestEvaluation: 'app.interview.schedule_dialog.request_evaluation',
          add: 'app.interview.schedule_dialog.add',
          assignmentsTitle: 'app.interview.schedule_dialog.assignments_title',
          assignmentsDesc: 'app.interview.schedule_dialog.assignments_desc',
        },
      },
    }),
    UnbiasedHiringModule.withTranslations({
      beta: {
        description: 'app.unbiased_hiring.beta.description',
        close: 'app.unbiased_hiring.beta.close',
      },
      infobox: {
        heading: 'app.unbiased_hiring.infobox.heading',
        message: 'app.unbiased_hiring.infobox.message',
        headingShort: 'app.unbiased_hiring.infobox.heading_short',
        messageShort: 'app.unbiased_hiring.infobox.message_short',
        headingAdmin: 'app.unbiased_hiring.infobox.heading_admin',
        messageAdmin: 'app.unbiased_hiring.infobox.message_admin',
        reviewEvaluations: 'app.unbiased_hiring.infobox.review_evaluations',
        messageWithNoAccessToJob: 'app.unbiased_hiring.infobox.message_with_no_access_to_job',
      },
      evaluateWithForm: 'app.unbiased_hiring.evaluate_with_form',
      evaluateWithFormTooltip: 'app.unbiased_hiring.evaluate_with_form_tooltip',
      addQuickEvaluationTooltip: 'app.interview.add_quick_evaluation_btn',
    }),
  ],
})
export class InterviewResultsModule {}
